import { List } from 'immutable'

type ImmutableAttribute = {
  get: (key: string, fallback?: string) => string
}

type AttributesCollection = {
  find: (predicate: (item: ImmutableAttribute) => boolean) => ImmutableAttribute | undefined
}

export const getAllergenListFromAttributes = (
  attributes: AttributesCollection = [],
): List<string> => {
  const allergensAttributes = attributes.find(
    (item: ImmutableAttribute) => item.get('title', '').toLowerCase() === 'allergen',
  )
  const allergenString = allergensAttributes ? allergensAttributes.get('value', '') : ''
  const allergenSplitArray = allergenString.split(/,\s+/)
  const allergenArray = allergenSplitArray
    .reduce<string[]>((words: string[], word: string) => [...words, ...word.split(' ')], [])
    .filter((value: string, index: number, values: string[]) => values.indexOf(value) === index)
    .filter((item: string) => item)

  return List(allergenArray)
}
